type PopoverBackdropProps = {
  isVisible: boolean;
};

const PopoverBackdrop = ({ isVisible }: PopoverBackdropProps) => {
  if (!isVisible) return;
  return (
    <div
      id="popover-backdrop"
      className="fixed inset-0 z-10 cursor-default bg-heading/20 backdrop-blur-[1px] transition-all duration-500"
    />
  );
};

export default PopoverBackdrop;
